import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attend-btn",
  "use": "icon-attend-btn-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-attend-btn\">\n<path d=\"M7 5L10 8L7 11\" stroke=\"#60BF52\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<rect x=\"0.5\" y=\"0.5\" width=\"15\" height=\"15\" rx=\"3.5\" stroke=\"#60BF52\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol